/* eslint-disable react/jsx-max-depth */ import { isEmpty, upperCase } from 'lodash';
import T from 'prop-types';
import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import List from '../../../components/list/List';
import { softwares } from '../../../components/mapView/constants';
import Activity from '../../../components/timeline/Activity';
import { DEFAULT_CURRENCY, GST } from '../../../constants/price';
import { SMART_SELECTION_DELIVERY_METHOD } from '../../../constants/product';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId } from '../../../utilities/membership';
import { userHasActiveMembership } from '../../../utilities/user';
import ChargeItem from '../../billing/Invoice/ChargeItem';
import { InvoiceTotal } from '../../billing/Invoice/InvoiceTotal';
var Invoice = function(param) {
    var job = param.job;
    var _softwares_entities_job_customer_software;
    var quote = job.quote;
    var _ref = quote || {
        currency: DEFAULT_CURRENCY,
        gst: GST
    }, currency = _ref.currency, gst = _ref.gst;
    var buyNowItems = quote.charges.filter(function(param) {
        var type = param.type, details = param.details;
        return type === 'data' && details.delivery_method === SMART_SELECTION_DELIVERY_METHOD.AUTOMATIC;
    });
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            membershipPriceId: state.order.membershipPriceId
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    var membership = useMemo(function() {
        if (quote.membership) {
            var _quote_membership = quote.membership, name = _quote_membership.name, amount = _quote_membership.amount;
            var extra = Math.round(amount * (gst / 100));
            return {
                name: name,
                taxes: [
                    {
                        display_name: 'GST',
                        price: {
                            extra: extra
                        }
                    }
                ],
                subtotal: amount,
                grand_total: Math.round(amount + extra),
                currency: {
                    name: currency.name,
                    scale_factor: currency.scale_factor
                }
            };
        }
        return null;
    }, [
        gst,
        currency,
        quote.membership
    ]);
    var software = ((_softwares_entities_job_customer_software = softwares.entities[job.customer_software]) === null || _softwares_entities_job_customer_software === void 0 ? void 0 : _softwares_entities_job_customer_software.name) || null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "InvoiceActivity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-2 font-weight--600 font-18"
    }, /*#__PURE__*/ React.createElement(Activity.Card.Type, {
        type: "QUOTE CREATED"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2 font-weight--400 font-16"
    }, text('buyItems', {
        title: upperCase(text('buyNow'))
    })), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "quote-card mb-3 pr-xl-0"
    }, /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "p-3 charge-item"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "title mb-2"
    }, "1. ", text('dataInDatabase')), /*#__PURE__*/ React.createElement("div", {
        className: "px-3"
    }, /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless"
    }, buyNowItems.map(function(param, index) {
        var discounts = param.discounts, details = param.details, price = param.price, fees = param.fees, member_discounts_preview = param.member_discounts_preview;
        return /*#__PURE__*/ React.createElement(ChargeItem, {
            key: index,
            displayName: text("".concat(details.category_name, "3D")),
            discounts: isMembershipPriceId(membershipPriceId) ? member_discounts_preview : discounts,
            details: details,
            price: price,
            fees: fees,
            quote: quote,
            isIndividualDiscountVisible: !userHasActiveMembership(currentUser) && !isMembershipPriceId(membershipPriceId),
            hideArea: true
        });
    }), !isEmpty(quote.discounts) && quote.discounts.map(function(discount, i) {
        var _discount_price;
        return /*#__PURE__*/ React.createElement(List.Item, {
            className: "discount font-pink pl-3 pt-1 font-italic",
            key: i,
            description: discount.display_name,
            value: "-".concat(formatCurrency((_discount_price = discount.price) === null || _discount_price === void 0 ? void 0 : _discount_price.subtotal, currency.name, currency.scale_factor, {}, true))
        });
    }))))), membership ? /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "quote-card mb-3"
    }, /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "p-3 charge-item"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "title mb-2"
    }, "2. ", text('membership')), /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless"
    }, /*#__PURE__*/ React.createElement(List.Item, {
        className: "item price px-3",
        value: formatCurrency(membership.subtotal, currency.name, currency.scale_factor, {}, true),
        description: membership.name
    })))) : null), /*#__PURE__*/ React.createElement("hr", {
        className: "totals-divider m-0"
    }), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        lg: 12,
        xl: 6,
        className: "pr-xl-0"
    }, /*#__PURE__*/ React.createElement(InvoiceTotal, {
        quote: job === null || job === void 0 ? void 0 : job.quote,
        currentUser: currentUser,
        membershipPriceId: membershipPriceId,
        selectedMembership: membership,
        subtotalText: text('subtotal'),
        grandTotalText: text('total')
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 mt-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "font-weight-bold"
    }, text('software'), ": "), /*#__PURE__*/ React.createElement("span", null, software, " ")), /*#__PURE__*/ React.createElement("div", {
        className: "terms-and-conditions"
    }, text('orderSubjectAgreement', {
        link: /*#__PURE__*/ React.createElement(Link, {
            key: "urlTerms",
            to: {
                pathname: process.env.LARKI_URL_TERMS
            },
            target: "_blank"
        }, "Customer ", text('termsAndConditions'))
    })));
};
Invoice.propTypes = {
    job: T.object
};
export default Invoice;
